var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('RegisterModal'),_c('ResetCompleteModal'),_c('ResetPasswordModal'),_c('AcceptTermsModal'),_c('LoginModal'),_c('AchievementModal'),_c('SurveyModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }